import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TableModule } from 'primeng/table';

import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteModule } from 'primeng/autocomplete';
 
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import {DialogModule} from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';
import {FieldsetModule} from 'primeng/fieldset';
import {ChartModule} from 'primeng/chart';
import {AccordionModule} from 'primeng/accordion';

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CalendarModule } from 'primeng/calendar';
import { AppInterceptorService } from './services/shared/app-interceptor.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { OrderByPipe } from './shared/order-by.pipe';
import { PanelModule } from 'primeng/panel';
import { PrintgridModule } from './shared/printgrid/printgrid.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LanguageModule } from './shared/language/language.module';
import { ConfirmationService } from 'primeng/api';
import { MasterPageComponent } from './master-page/master-page.component';
import { MenubarModule } from 'primeng/menubar';
import { PasswordModule } from 'primeng/password';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EnvServiceProvider } from './shared/environment-service/env.service.provider';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/app/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,   
    OrderByPipe,
    MasterPageComponent  
  ],
  imports: [
    ConfirmDialogModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    InputTextareaModule,
    TableModule,
    InputNumberModule,
    AutoCompleteModule,
    InputTextModule,
    RippleModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    SidebarModule,
    FieldsetModule,
    ChartModule,
    AccordionModule,
    SlickCarouselModule,
    AppRoutingModule,
    CalendarModule,
    NgxSpinnerModule,
    ToastModule,
    PanelModule,
    PrintgridModule,
    HighchartsChartModule,
    LanguageModule,
    MenubarModule,
    PasswordModule,
 
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      isolate: true,
      defaultLanguage: 'en',
    }),
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AppInterceptorService,
    multi: true
  },
    MessageService,
    EnvServiceProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
